export default "__VITE_ASSET__a47c2f96__"